// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3ScNV","errors":"Errors_errors__2wOsg"};